import { lightTheme, darkTheme } from '@controlrooms/design-tokens';

export type IconTheme = {
  color: string;
  primary: string;
  secondary: string;
  tertiary: string;
};

export const iconTheme = Object.fromEntries(
  Object.entries({ light: lightTheme, dark: darkTheme }).map(([key, theme]) => [
    key,
    {
      color: theme.color.text.core['-primary'],
      primary: theme.color.text.core['-primary'],
      secondary: theme.color.text.core['-secondary'],
      tertiary: theme.color.focus[1],
    },
  ]),
);

// Legacy exports for backward compatibility
export const iconDarkTheme: IconTheme = iconTheme.dark as IconTheme;
export const iconLightTheme: IconTheme = iconTheme.light as IconTheme;
